import { createGlobalStyle } from 'styled-components';
import primitives from '@components/styles/primitives';

export const { color, layout, typography } = primitives;

const breakpoint6 = 1200;
const breakpoint8 = 1441;
const breakpoint9 = 1901;
// hardcoding these for now as Veneer changed its breakpoints on newer versions
const breakpoint0 = 575;
const breakpoint4 = 991;

export const extraBigDesktop = ` @media (min-width: ${breakpoint9}px)`;
export const bigDesktop = ` @media (min-width: ${breakpoint8}px)`;
export const smallDesktop = ` @media (max-width: ${breakpoint6}px)`;
export const tablet = ` @media (max-width: ${breakpoint4}px)`;
export const mobile = ` @media (max-width: ${breakpoint0}px)`;

const GlobalStyles = createGlobalStyle`
    h1, h2, h3, h4, p {
        margin: 0;
        padding: 0;
    }
`;

export default GlobalStyles;

export const paddingLeftBigDesktop = 'max(36px, calc((100% - 1440px) / 2))';
export const paddingLeftDefaultDesktop = 'max(72px, calc((100% - 1296px) / 2))';
export const paddingLeftSmallDesktop = 'max(36px, calc((100% - 1296px) / 2))';
export const headerHeight = 60;
